import { setLocaleData } from '@wordpress/i18n';

setLocaleData({ '': {} }, 'reseller-store');
